var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-title-page flex-container"},[_c('hjxHeader',{ref:"hjxHeader",attrs:{"title":_vm.pageTitle}}),_c('div',{staticClass:"body-wrap"},[_c('div',{staticClass:"body"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }